import { CloseOutlined } from "@ant-design/icons";
import { Button, DatePicker, Form, Select } from "antd";
import { useEffect, useState } from "react";

const vidOptions = [
  { label: "Клиенты в клубе", value: 0 },
  { label: "Визиты за период", value: 1 },
]

const VisitFilter = ({ current, onClose }) => {
  const [item, setItem] = useState({...current});
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(current);
  }, [current]);

  const onValuesChange = (value) => {
    setItem({...item, ...value});
  }

  const onSave = () => {
    onClose(item);
  }

  return<div className="sport-modal">
    <div className="sport-modal-overlay" onMouseDown={e => e.target === e.currentTarget && onClose(false)}>
      <div className="sport-modal-content" onMouseDown={e => e.stopPropagation()}>
        <div className="sport-modal-title">
          <span>Фильтр визитов</span>
          <CloseOutlined className="sport-section-title-close" onClick={() => onClose()} style={{ zIndex: 9 }}   />
        </div>
        <Form form={form} onValuesChange={onValuesChange} labelCol={{ span: 4 }} wrapperCol={{ }} colon={false} layout="inline">
          <Form.Item name="vid" label="Вид" className="record-form-item-with-margin-bottom-mobile">
            <Select  options={vidOptions} className="client-filter-select"/>
          </Form.Item>
          {item.vid ? (
            <Form.Item name="dateBeg" label="Начало" className="record-form-item-with-margin-bottom-mobile">
              <DatePicker format="DD.MM.YYYY" className="client-filter-select"
                onChange={(date) => {
                  setItem(prev => ({ ...prev, dateBeg: date }));
                  form.setFieldValue("dateBeg", date);}}/>
            </Form.Item>
          ) : null}
          {item.vid ? (
            <Form.Item name="dateEnd" label="Окончание" className="client-filter-select">
              <DatePicker format="DD.MM.YYYY" className="client-filter-select"
                onChange={(date) => {
                  setItem(prev => ({ ...prev, dateEnd: date }));
                  form.setFieldValue("dateEnd", date);}}/>
            </Form.Item>
          ) : null}


          
          <Button className="sport-btn" onClick={onSave} style={{width: "100%"}}>ОК</Button>
        </Form>
      </div>
    </div>
  </div>
}

export default VisitFilter;